import { useSelector } from "react-redux";
import { selectFeatureFlags } from "../../features/parameters/ParametersPage.selector";
import { useCallback } from "react";

export enum FeatureName {
	live_pricing = "live_pricing",
	use_market_data = "use_market_data",
	use_tpr_site = "use_tpr_site",
	contract_pages = "contract_pages",
	geco_endpoint = "geco_endpoint",
	is_goo_only_enabled = "is_goo_only_enabled",
	use_react_virtualisation = "use_react_virtualisation",
	pricing_stepper_defaults = "pricing_stepper_defaults",
	pricing_stepper_negative_price = "pricing_stepper_negative_price",
	pricing_stepper_curtailability_forward = "pricing_stepper_curtailability_forward",
	powerbridge_negative_price_condition = "powerbridge_negative_price_condition",
	us_cluster_support = "us_cluster_support",
	powerbridge_curtailability_forward = "powerbridge_curtailability_forward",
	pricing_stepper_cap_floor = "pricing_stepper_cap_floor",
	pricing_stepper_cross_date = "pricing_stepper_cross_date",
	powerbridge_cap_floor_condition = "powerbridge_cap_floor_condition",
	enhanced_settlement_period_booking = "enhanced_settlement_period_booking",
	enable_pricing_addons_sync = "enable_pricing_addons_sync",
	enable_pricing_addons_pricing = "enable_pricing_addons_pricing",
	enable_spot_market_pricing = "enable_spot_market_pricing",
	enable_spot_market_booking = "enable_spot_market_booking",
}

export interface UseFeatureFlags {
	isFeature: (name: FeatureName, is_active: boolean) => boolean;
}

export function useFeatureFlags(): UseFeatureFlags {
	const features = useSelector(selectFeatureFlags);

	const isFeature = useCallback(
		(name: FeatureName, is_active: boolean): boolean => {
			const keys = Object.keys(features as any);
			const featureName: string | undefined = keys.find(
				(featureE: string) => featureE === name
			);

			return !!(
				features &&
				featureName &&
				features[featureName as string] === is_active
			);
		},
		[features]
	);
	return {
		isFeature,
	};
}
